import { ReducerFunctions } from "../../utils";
import { InventoryItemsCreate, InventoryItemsGet } from "./inventory";

export const inventory_items_reducer = ReducerFunctions(InventoryItemsCreate, {})
export const inventory_items_get_reducer = ReducerFunctions(InventoryItemsGet, {})